import q from '../query.js';
export const moneyCalculatorKey = `money-calculator`;
let items = {};
let sum = 0;
let count = 0;
export const useMoneyCalculator = () => q.query(moneyCalculatorKey, () => {
    return { sum, items, count };
}, []);
//# sourceMappingURL=index.js.map